module.exports = __webpack_public_path__ + "static/media/fbp-thumb.10568972.png";